<template>
  <MissingReturnAddressModal />
  <div class="flex max-h-screen min-h-screen w-full overflow-y-hidden">
    <Sidebar />

    <div class="grow">
      <div class="flex h-full max-h-full flex-col">
        <Header />
        <Main />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import MissingReturnAddressModal from '../../components/MissingReturnAddressModal/MissingReturnAddressModal.vue'
import Sidebar from '../../components/Sidebar/Sidebar.vue'

import Header from './components/Header/Header.vue'
import Main from './components/Main/Main.vue'
</script>
